export function initArchiveLoadMore() {
  const list = document.querySelector('[data-archive-list]');
  const button = document.querySelector('[data-archive-more]');

  if (!list || !button || typeof vegeArchive === 'undefined') {
    return;
  }

  // ラベルは i18n 版テーマから渡ってくる。渡ってこない環境（本番の日本語版）では日本語を使う。
  const label = (vegeArchive && vegeArchive.i18n) || {};
  const setLoading = (isLoading) => {
    button.disabled = isLoading;
    button.textContent = isLoading
      ? (label.loading || '読み込み中')
      : (label.more || 'もっと見る');
  };

  const appendBlocks = (html) => {
    const template = document.createElement('template');
    template.innerHTML = html.trim();

    // カテゴリで絞り込んだときは月見出しを出さない（data-archive-month が無い）ので、
    // 月ブロックだけを探すと追記先が見つからず1件も増えない。両方の形を拾う。
    template.content.querySelectorAll('.p-archive__block').forEach((block) => {
      const month = block.dataset.archiveMonth;
      const currentBlock = month
        ? list.querySelector(`[data-archive-month="${month}"]`)
        : list.querySelector('.p-archive__block--nomonth');

      if (currentBlock) {
        const currentList = currentBlock.querySelector('.p-archive__lists');
        // カード本体は .c-caseCard（.c-caseList は中の要素名で、ここでは一致しない）
        const newItems = block.querySelectorAll('.c-caseCard');
        newItems.forEach((item) => currentList.appendChild(item));
        return;
      }

      list.appendChild(block);
    });
  };

  button.addEventListener('click', async () => {
    if (button.disabled) {
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('action', 'vege_archive_load_more');
    formData.append('nonce', vegeArchive.nonce);
    formData.append('offset', button.dataset.offset || '0');
    formData.append('perPage', button.dataset.perPage || '5');
    formData.append('termId', button.dataset.termId || '0');

    try {
      const response = await fetch(vegeArchive.ajaxUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      });
      const result = await response.json();

      if (!result.success || !result.data.html) {
        button.closest('.p-archive__btn')?.remove();
        return;
      }

      appendBlocks(result.data.html);
      button.dataset.offset = result.data.nextOffset;

      if (!result.data.hasMore) {
        button.closest('.p-archive__btn')?.remove();
      }
    } catch (error) {
      button.textContent = label.retry || '再読み込みする';
      button.disabled = false;
      return;
    }

    setLoading(false);
  });
}
